import Navbar from '../components/Navbar/Navbar';
import Intro from '../components/Mainpage/Intro';
import CompanyCards from '../components/Mainpage/CompanyCards';
import Features from '../components/Mainpage/Features';
import Dyno from '../components/Mainpage/Dyno';
import Divy from '../components/Mainpage/Divy';
import Numo from '../components/Mainpage/Numo';
import Divider from '../components/Mainpage/Divider';
import Contact from '../components/Mainpage/Contact';
import SmoothScrolling from '../components/Mainpage/SmoothScrolling';

import './App.css';

function Mainpage() {
  return (
    <SmoothScrolling>
    <div style={{ 
      position: 'relative', 
      minHeight: '100vh',
      minHeight: 'calc(var(--vh, 1vh) * 100)'
    }}>
      <div style={{
        backgroundColor: 'black',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: '-1000',
        pointerEvents: 'none', // Allow clicks to pass through to content
      }}></div>
      <div style={{
        border: '16px solid black',
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: '1005',
        pointerEvents: 'none', // Allow clicks to pass through to content
      }}></div>
      <div style={{paddingRight: '16px', paddingLeft: '16px'}}>
        <Navbar/>
        <Intro/>
        <CompanyCards/>
        <Features/>

        <Dyno/>
        <Divider/>
        <Divy/>
        <Divider/>  
        <Numo/>
        <Divider/>  
        <Contact/>
      </div>
      {/* Black overlay that stays fixed at the bottom */}
      <div style={{
        position: 'fixed',
        top: '100vh',
        width: '100%',
        height: '200px',
        backgroundColor: 'black',
        zIndex: '1005',
      }}></div>
    </div>    
    </SmoothScrolling>
  );
}

export default Mainpage;
